import { render, staticRenderFns } from "./PrettyBookLink.vue?vue&type=template&id=1726b172&scoped=true"
import script from "./PrettyBookLink.vue?vue&type=script&lang=js"
export * from "./PrettyBookLink.vue?vue&type=script&lang=js"
import style0 from "./PrettyBookLink.vue?vue&type=style&index=0&id=1726b172&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1726b172",
  null
  
)

export default component.exports